module.exports = __webpack_public_path__ + "img/02o_marketing.ccf69072.jpg";